module.exports = __webpack_public_path__ + "media/images/views/home/benefit/benefit-1-ec4ba6209d29acfcb68683ff7de9db56.png";